import type { Bid } from "@anaconda/core/bid/types"
import { useWalletConnect } from "../wallet-connect/hooks"

/**
 * Match the bid's maker against *either* connected chain.
 *
 * `unionAddress` is `resolvePrimaryUnionAddress`, which is `evm ?? solana` — so
 * with both wallets connected (the Privy default) it is the EVM address and a
 * Solana maker never matches, hiding Cancel on your own Solana bid. `WalletPreview`
 * already checks both, which is why such a row reads "You" with no action.
 *
 * EVM addresses are case-insensitive; Solana base58 is not, so only the EVM side
 * is lowercased.
 */
export const useIsUserBidder = (bid: Bid) => {
  const { evmUnionAddress, solanaUnionAddress } = useWalletConnect()
  const maker = bid.order.maker

  if (solanaUnionAddress && maker === solanaUnionAddress) return true

  return Boolean(
    evmUnionAddress && maker.toLowerCase() === evmUnionAddress.toLowerCase(),
  )
}
